// @file Network requests related to wall attachment setting permissions from surface
/* eslint-disable no-return-await, no-template-curly-in-string */
import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { AttachmentTypeSettingsPermissions, HashId } from '@@/types'
import type { JsonAPIResource, JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

class WallAttachmentSettingPermissionsApi extends FetchableObject {
  public static get url(): string {
    return `/api/\${ apiVersion }/libraries/\${ libraryHashId }/attachment-type-settings/permissions`
  }

  public static async fetchWallAttachmentSettingPermissions(
    libraryHashId: HashId,
    fetchOptions: VersionedFetchOptions = { apiVersion: 1 },
  ): Promise<AttachmentTypeSettingsPermissions> {
    const { apiVersion, ...otherFetchOptions } = fetchOptions
    const response: JsonAPIResponse<AttachmentTypeSettingsPermissions> = await fetchJson(
      this.buildUrl(this.url, { apiVersion, libraryHashId }),
      {
        method: HTTPMethod.get,
        ...otherFetchOptions,
      },
    )
    const permissions = (response.data as JsonAPIResource<AttachmentTypeSettingsPermissions>)?.attributes
    if (permissions == null) throw new Error('Invalid response from server')
    return permissions
  }
}

export { WallAttachmentSettingPermissionsApi }
